export const URL_API =
  process.env.NODE_ENV !== "production"
    ?  "http://localhost:8081/"
    : //'https://beceonline.herokuapp.com/';
    'https://bece-test.herokuapp.com/';
